<div class="button-container">
  <button  title="Закрыть"
           class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div class="dialog">
  <div class="dialog-header">
    <span>
      <mat-icon class="icon" svgIcon="alarm"></mat-icon>
    </span>
    <span>Очистка ИОМ</span>
  </div>

  <div class="dialog-content">
    Вы уверены, что хотите очистить данный ИОМ?
  </div>

  <div class="dialog-actions">
    <button class="back-button" [mat-dialog-close]="true">Отмена</button>
    <button class="primary-button" (click)="clearIom()" [mat-dialog-close]="true">ОК</button>
  </div>
</div>

